import { fork, put, takeLatest, select, } from 'redux-saga/effects';
import { challengeActions } from '@sportheroes/oly-engine-store';
import { getType } from '../../utils';
import { userRegisteredChallengesDataSelector } from './selectors';
import actions from './actions';
export function* loadUserRegisteredChallenges(apis, action) {
    try {
        const { clientId, userId, limit, skip, status, search, challengeType } = action.payload;
        const fullResponse = yield apis.userApi
            .getUserRegisteredChallengesNew({
            clientId,
            userId,
            limit,
            skip,
            status,
            search,
            challengeType,
        })
            .then((p) => p.request);
        const UserRegisteredChallengesData = yield select(userRegisteredChallengesDataSelector);
        const prevData = UserRegisteredChallengesData || [];
        const nextData = fullResponse.data || [];
        const newData = [...prevData, ...nextData];
        yield put(actions.loadUserRegisteredChallengesSuccess({
            ...fullResponse,
            data: newData,
            meta: fullResponse.meta,
        }));
    }
    catch (error) {
        yield put(actions.loadUserRegisteredChallengesError(true));
    }
}
export function* loadUserGroupChallengeStats(apis, action) {
    const { challengeId, clientId, userId } = action.payload;
    try {
        const data = yield apis.userApi
            .getUserChallengeStats({
            challengeId,
            clientId,
            userId,
        })
            .then(p => p.request);
        yield put(actions.loadUserGroupChallengeStatsSuccess({ data }));
    }
    catch (error) {
        yield put(actions.loadUserGroupChallengeStatsError(true));
    }
}
export function* challengeRegister(apis, action) {
    const { userId, clientId, challengeId, code, restart, groupId, language, defaultLanguage, } = action.payload;
    const payload = {
        challenge: challengeId,
        restart,
    };
    if (groupId) {
        payload.group = groupId;
    }
    if (code) {
        payload.code = code;
    }
    try {
        if (restart) {
            yield apis.userApi
                .restartChallenge({
                userId,
                clientId,
                challengeId,
            })
                .then(p => p.request);
        }
        else {
            yield apis.userApi
                .registerChallenge({
                userId,
                clientId,
                payload,
            })
                .then(p => p.request);
        }
        yield put(actions.challengeRegisterSuccess());
        // ``isCurrentUserRegister`` utils stills needs userChallenge in challenge updated after a registration.
        // To migrate next.
        yield put(challengeActions.loadChallenge({
            challengeId,
            clientId,
            language,
            defaultLanguage,
        }));
        // Load userChallenge after a registration
        yield put(actions.loadUserChallenge({
            challengeId,
            clientId,
            userId,
        }));
    }
    catch (error) {
        yield put(actions.challengeRegisterError(error));
    }
}
export function* loadUserChallenge(apis, action) {
    const { challengeId, clientId, userId } = action.payload || {};
    try {
        const data = yield apis.userApi
            .getUserChallenge({
            challengeId,
            clientId,
            userId,
        })
            .then(p => p.request);
        yield put(actions.loadUserChallengeSuccess(data));
    }
    catch (error) {
        yield put(actions.loadUserChallengeError(error));
    }
}
export function* updateUserChallenge(apis, action) {
    const { challengeId, clientId, data, userId } = action.payload;
    try {
        yield apis.userApi
            .updateUserChallenge({
            challengeId,
            clientId,
            userId,
            data,
        })
            .then(p => p.request);
        yield put(actions.updateUserChallengeSuccess());
        yield put(actions.loadUserChallenge({
            challengeId,
            clientId,
            userId,
        }));
    }
    catch (error) {
        yield put(actions.updateUserChallengeError());
    }
}
export function* getUserChallengeActivities(apis, action) {
    const { challengeId, clientId, userId } = action.payload;
    try {
        const data = yield apis.userApi
            .getUserChallengeActivities({
            challengeId,
            clientId,
            userId,
        })
            .then(p => p.request);
        yield put(actions.loadUserChallengeActivitiesSuccess({ data }));
    }
    catch (error) {
        yield put(actions.loadUserChallengeActivitiesError());
    }
}
export function* getUserChallengeActions(apis, action) {
    const { challengeId, clientId, userId } = action.payload;
    try {
        const data = yield apis.userApi
            .getUserChallengeActions({
            challengeId,
            clientId,
            userId,
        })
            .then(p => p.request);
        yield put(actions.loadUserChallengeActionsSuccess({ data }));
    }
    catch (error) {
        yield put(actions.loadUserChallengeActionsError());
    }
}
export function* getUserChallengeActivitiesAround(apis, action) {
    const { challengeId, clientId, userId } = action.payload;
    try {
        const data = yield apis.userApi
            .getUserChallengeActivitiesAround({
            challengeId,
            clientId,
            userId,
        })
            .then(p => p.request);
        yield put(actions.loadUserChallengeActivitiesAroundSuccess({ data }));
    }
    catch (error) {
        yield put(actions.loadUserChallengeActivitiesAroundError());
    }
}
export function* getUserChallengeAttempts(apis, action) {
    const { challengeId, clientId, userId } = action.payload;
    try {
        const data = yield apis.userApi
            .getUserChallengeAttempts({
            challengeId,
            clientId,
            userId,
        })
            .then(p => p.request);
        yield put(actions.loadUserChallengeAttemptsSuccess({ data }));
    }
    catch (error) {
        yield put(actions.loadUserChallengeAttemptsError());
    }
}
export function* getUserGroupChallenge(apis, action) {
    const { resourceType, resourceId, id, withMembers } = action.payload || {};
    try {
        const data = yield apis.groupsApi
            .getOneResourceGroup({
            resourceType,
            resourceId,
            id,
            withMembers,
        })
            .then((p) => p.request);
        yield put(actions.loadUserGroupChallengeSuccess(data));
    }
    catch (error) {
        yield put(actions.userGroupChallengeRequestError());
    }
}
export function* setUserGroupChallenge(action) {
    yield put(actions.setUserGroupChallengeSuccess(action.payload));
}
export function* watchUserRegisteredChallenges(apis) {
    yield takeLatest(getType(actions.loadUserRegisteredChallenges), loadUserRegisteredChallenges, apis);
}
export function* watchLoadUserGroupChallengeStats(apis) {
    yield takeLatest(getType(actions.loadUserGroupChallengeStats), loadUserGroupChallengeStats, apis);
}
export function* watchRegisterChallenge(apis) {
    yield takeLatest(getType(actions.challengeRegister), challengeRegister, apis);
}
export function* watchLoadUserChallenge(apis) {
    yield takeLatest(getType(actions.loadUserChallenge), loadUserChallenge, apis);
}
export function* watchUpdateUserChallenge(apis) {
    yield takeLatest(getType(actions.updateUserChallenge), updateUserChallenge, apis);
}
export function* watchGetUserChallengeActivities(apis) {
    yield takeLatest(getType(actions.loadUserChallengeActivities), getUserChallengeActivities, apis);
}
export function* watchGetUserChallengeActions(apis) {
    yield takeLatest(getType(actions.loadUserChallengeActions), getUserChallengeActions, apis);
}
export function* watchGetUserChallengeActivitiesAround(apis) {
    yield takeLatest(getType(actions.loadUserChallengeActivitiesAround), getUserChallengeActivitiesAround, apis);
}
export function* watchGetUserChallengeAttempts(apis) {
    yield takeLatest(getType(actions.loadUserChallengeAttempts), getUserChallengeAttempts, apis);
}
export function* watchLoadUserGroupChallenge(apis) {
    yield takeLatest(getType(actions.loadUserGroupChallengeRequest), getUserGroupChallenge, apis);
}
export function* watchSetUserGroupChallenge() {
    yield takeLatest(getType(actions.setUserGroupChallengeAttempt), setUserGroupChallenge);
}
export const userChallengesSagas = (apis) => [
    fork(watchGetUserChallengeActivities, apis),
    fork(watchGetUserChallengeActions, apis),
    fork(watchGetUserChallengeActivitiesAround, apis),
    fork(watchGetUserChallengeAttempts, apis),
    fork(watchLoadUserChallenge, apis),
    fork(watchLoadUserGroupChallengeStats, apis),
    fork(watchRegisterChallenge, apis),
    fork(watchUpdateUserChallenge, apis),
    fork(watchUserRegisteredChallenges, apis),
    fork(watchLoadUserGroupChallenge, apis),
    fork(watchSetUserGroupChallenge),
];
export default userChallengesSagas;
